import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Route, Redirect, RouteProps } from "react-router-dom";
import UserContext from "../../contexts/UserContext";

const AuthorizedRoute: React.FC<RouteProps> = observer(
  ({ component, ...props }) => {
    const user = useContext(UserContext);

    if (user.isLoggedIn()) {
      return <Route {...props} component={component} />;
    } else {
      return <Route {...props} render={() => <Redirect to="/login" />} />;
    }
  }
);

export default AuthorizedRoute;
